/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const Redo20 = createSVGComponent('Redo20', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 20 20",
  "fill": "currentColor",
  "width": 20,
  "height": 20
}, [{
  "elem": "path",
  "attrs": {
    "d": "M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6\tl-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z"
  }
}]);

export { Redo20 as default };
